import { render, staticRenderFns } from "./DisturbioEmocional.vue?vue&type=template&id=b3272c4a"
import script from "./DisturbioEmocional.vue?vue&type=script&lang=js"
export * from "./DisturbioEmocional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports